import { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Controller, useForm } from 'react-hook-form';
import { Button, Table, TableCell, TableContainer, TableRow, TableHead, TableBody, TextField } from '@mui/material';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import { getEquipmentCategoriesByQuery, postEquipmentCategories, patchEquipmentCategories, deleteEquipmentCategories } from 'components/axios/equipmentCategoryAxios';
import { deleteMaintenanceCheckupItems, getMaintenanceCheckupItemsByQuery } from 'components/axios/maintenanceCheckupItemsAxios';
import CustomFormEnumSelect from 'components/select/CustomFormEnumSelect';
import { LoadingButton } from '@mui/lab';
import axios from 'axios';
import MainCard from 'components/MainCard';
import { useEnumApi } from 'contexts/EnumApiContext';
import PdfLayer from 'components/layer/PdfLayer';
import { customFileAxios } from 'components/axios/customAxios';

const CheckListMaintenanceSetting = () => {
  const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode, equipmentCategoryLevel1s } = useEnumApi();
  const { t } = useTranslation();

  // modal 관련
  const { openModal } = useModals();
  let [alertMessage, setAlertMessage] = useState('');
  
  const handleAlertClick = () => {
    openModal(modals.alertModal, {
      onClose : () => {
      },
      message: alertMessage,
     });
  };

  const { register : level1Register, handleSubmit : level1HandleSubmit, reset : level1Reset
    , formState : {isDirty : level1IsDirty, errors : level1Errors } } = useForm({});
  const { register : level1UpdateRegister, handleSubmit : level1UpdateHandleSubmit, reset : level1UpdateReset
    , formState : {isDirty : level1UpdateIsDirty, errors : level1UpdateErrors } } = useForm({});
    
  const { register : level2Register, handleSubmit : level2HandleSubmit, reset : level2Reset
    , formState : {isDirty : level2IsDirty, errors : level2Errors } } = useForm({});
  const { register : level2UpdateRegister, handleSubmit : level2UpdateHandleSubmit, reset : level2UpdateReset
    , formState : {isDirty : level2UpdateIsDirty, errors : level2UpdateErrors } } = useForm({});

  const { control : checkListControl, register : checkListRegister, handleSubmit : checkListHandleSubmit, reset : checkListReset
    , formState : {isDirty : checkListIsDirty, errors : checkListErrors } } = useForm({});
  const { control : checkListUpdateControl, register : checkListUpdateRegister, handleSubmit : checkListUpdateHandleSubmit, reset : checkListUpdateReset
    , formState : {isDirty : checkListUpdateIsDirty, errors : checkListUpdateErrors } } = useForm({});

  let [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
  let [maintenanceCheckupItems, setMaintenanceCheckupItems] = useState([]);

  let [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState(0);
  let [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState(0);
  let [maintenanceCheckListItemFileId, setMaintenanceCheckListItemFileId] = useState(null);
  
  let [equipmentCategoryLevel1sSelected, setEquipmentCategoryLevel1sSelected] = useState([]);
  let [equipmentCategoryLevel2sSelected, setEquipmentCategoryLevel2sSelected] = useState([]);

  let [equipmentCategoryLevel1sModifyView, setEquipmentCategoryLevel1sModifyView] = useState([]);
  let [equipmentCategoryLevel2sModifyView, setEquipmentCategoryLevel2sModifyView] = useState([]);
  let [maintenanceCheckupItemsModifyView, setMaintenanceCheckupItemsModifyView] = useState([]);
    
  useEffect(()=> {
    if (equipmentCategoryLevel1s && equipmentCategoryLevel1s.length > 0) {
      equipmentCategoryLevel1List();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipmentCategoryLevel1s]);
  
  // 설비대분류 목록
  const equipmentCategoryLevel1List = () => {
    if (equipmentCategoryLevel1s && equipmentCategoryLevel1s.length > 0) {
      let arr = Array.from({ length: equipmentCategoryLevel1s.length }, () => false);
      setEquipmentCategoryLevel1sModifyView(arr);

      let arr2 = Array.from({ length: equipmentCategoryLevel1s.length }, () => null);
      setEquipmentCategoryLevel1sSelected(arr2);

      selectEquipmentCategoryLevel1(0, equipmentCategoryLevel1s[0]);
    } else {
      setEquipmentCategoryLevel1sModifyView([]);
    }
  };

  // 설비대분류 선택
  const selectEquipmentCategoryLevel1 = (i, data) => {
    equipmentCategoryLevel1Id = data.id;
    setEquipmentCategoryLevel1Id(data.id);
    setEquipmentCategoryLevel2Id(0);
    setMaintenanceCheckupItems([]);
    let copy = [...equipmentCategoryLevel1sSelected];
    copy = Array.from({ length: copy.length }, () => null);
    copy[i] = "select_active";
    setEquipmentCategoryLevel1sSelected(copy);
    equipmentCategoryLevel2List();
  };

  // 설비대분류등록
  let onSubmitLevel1 = (data) => {
    const level1Name = data.level1Name;

    let body = {
      id: null,
      name: level1Name,
      depth: 1
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        postEquipmentCategories(body).then((res) => {
          equipmentCategoryLevel1List();
          alertMessage = t('message.common.alert.write.done');
          setAlertMessage(alertMessage);
          handleAlertClick();
        }).catch((err) => {
          console.log(err);
          if (!err.response?.data?.message) {
            alertMessage = err.message;
            setAlertMessage(alertMessage);
            handleAlertClick();
          } else if (err.response.data.message) {
            alertMessage = err.response.data.message;
            setAlertMessage(alertMessage);
            handleAlertClick();
          }
        });
      },
      onClose : () => {
        //  console.log('close');
      },
      message: t('message.common.alert.write.question'),
    });
    level1Reset();
  };

  // 설비대분류수정
  let onSubmitLevel1Update = (data) => {
    const level1Id = data.level1Id;
    const level1Name = data.level1NameUpdate;

    let body = {
      id: level1Id,
      name: level1Name
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        patchEquipmentCategories(body).then((res) => {
          equipmentCategoryLevel1List();
          alertMessage = t('message.common.alert.modify.done');
          setAlertMessage(alertMessage);
          handleAlertClick();
          //level1UpdateReset();
          //level1Reset();
        }).catch((err) => {
          console.log(err);
          if (!err.response?.data?.message) {
            alertMessage = err.message;
            setAlertMessage(alertMessage);
            handleAlertClick();
          } else if (err.response.data.message) {
            alertMessage = err.response.data.message;
            setAlertMessage(alertMessage);
            handleAlertClick();
          }
        });
      },
      onClose : () => {
        //  console.log('close');
      },
      message: t('message.common.alert.modify.question'),
    });
  };

  // 설비대분류 삭제
  const handleEquipmentCategoryLevel1DeleteBtnClick = (param) => {
    openModal(modals.confirmModal, {
      onSubmit: (value) => {
        deleteEquipmentCategories(param).then((res) => {
          equipmentCategoryLevel1List();
        }).catch((err) => {
          console.log(err);
          if (!err.response?.data?.message) {
            alertMessage = err.message;
            setAlertMessage(alertMessage);
            handleAlertClick();
          } else if (err.response.data.message) {
            alertMessage = err.response.data.message;
            setAlertMessage(alertMessage);
            handleAlertClick();
          }
        });
      },
      onClose: () => {
      //  console.log('close');
      },
      message: t('message.common.alert.delete.question'),
    });
    level1Reset();
  };

  // 설비중분류 목록
  const equipmentCategoryLevel2List = async () => {
    const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
    await getEquipmentCategoriesByQuery(param).then((data) => {
      if (data && data._embedded) {
        const list = data._embedded.equipmentCategories;
        if (list) {
          setEquipmentCategoryLevel2s(list);
          let arr = Array.from({ length: list.length }, () => false);
          setEquipmentCategoryLevel2sModifyView(arr);

          let arr2 = Array.from({ length: list.length }, () => null);
          setEquipmentCategoryLevel2sSelected(arr2);
          selectEquipmentCategoryLevel2(0, list[0]);
        } else {
          setEquipmentCategoryLevel2s([]);
          setEquipmentCategoryLevel2sModifyView([]);
        }
      } else {
        setEquipmentCategoryLevel2s([]);
        setEquipmentCategoryLevel2sModifyView([]);
      }
    });
  };

  // 설비중분류 선택
  const selectEquipmentCategoryLevel2 = async(i, data) => {
     equipmentCategoryLevel2Id = data.id;
     setEquipmentCategoryLevel2Id(data.id);
     let copy = [...equipmentCategoryLevel2sSelected];
     copy = Array.from({ length: copy.length }, () => null);
     copy[i] = "select_active";
     setEquipmentCategoryLevel2sSelected(copy);
     maintenanceCheckupItemsList();
  };


  // 설비중분류등록
  let onSubmitLevel2 = (data) => {
    const level2Name = data.level2Name;

    let body = {
      parent: {
        id: equipmentCategoryLevel1Id
      },
      //      id : null,
      name: level2Name,
      depth: 2
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        postEquipmentCategories(body).then((res) => {
          equipmentCategoryLevel2List();
          alertMessage = t('message.common.alert.write.done');
          setAlertMessage(alertMessage);
          handleAlertClick();
        }).catch((err) => {
          console.log(err);
          if (!err.response?.data?.message) {
            alertMessage = err.message;
            setAlertMessage(alertMessage);
            handleAlertClick();
          } else if (err.response.data.message) {
            alertMessage = err.response.data.message;
            setAlertMessage(alertMessage);
            handleAlertClick();
          }
        });
      },
      onClose : () => {
        //  console.log('close');
      },
      message: t('message.common.alert.write.question'),
    });
    level2Reset();
  };

  // 설비중분류수정
  let onSubmitLevel2Update = (data) => {
    const level2Id = data.level2Id;
    const level2Name = data.level2NameUpdate;

    let body = {
      id: level2Id,
      name: level2Name
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        patchEquipmentCategories(body).then((res) => {
          equipmentCategoryLevel2List();
          alertMessage = t('message.common.alert.modify.done');
          setAlertMessage(alertMessage);
          handleAlertClick();
        }).catch((err) => {
          console.log(err);
          if (!err.response?.data?.message) {
            alertMessage = err.message;
            setAlertMessage(alertMessage);
            handleAlertClick();
          } else if (err.response.data.message) {
            alertMessage = err.response.data.message;
            setAlertMessage(alertMessage);
            handleAlertClick();
          }
        });
      },
      onClose : () => {
       //   console.log('close');
      },
      message: t('message.common.alert.modify.question'),
    });
  };

  // 설비중분류 삭제
  const handleEquipmentCategoryLevel2DeleteBtnClick = (param) => {
    openModal(modals.confirmModal, {
      onSubmit: (value) => {
        deleteEquipmentCategories(param).then((res) => {
          equipmentCategoryLevel2List();
          setEquipmentCategoryLevel2Id(0);
        }).catch((err) => {
          console.log(err);
          if (!err.response?.data?.message) {
            alertMessage = err.message;
            setAlertMessage(alertMessage);
            handleAlertClick();
          } else if (err.response.data.message) {
            alertMessage = err.response.data.message;
            setAlertMessage(alertMessage);
            handleAlertClick();
          }
        });
        level2Reset();
      },
      onClose: () => {
      //  console.log('close');
      },
      message: t('message.common.alert.delete.question'),
    });
  };

  // 유지점검항목 목록
  const maintenanceCheckupItemsList = async () => {
    const param = { "chkItemType":"M","equipmentCtgr.id": equipmentCategoryLevel2Id, size : 100};
    await getMaintenanceCheckupItemsByQuery(param).then((data) => {
      if (data && data._embedded) {
        const list = data._embedded.maintenanceCheckupItem;
        if (list) {
          setMaintenanceCheckupItems(list);
          let arr = Array.from({ length: list.length }, () => false);
          setMaintenanceCheckupItemsModifyView(arr);
        } else {
          setMaintenanceCheckupItems([]);
          setMaintenanceCheckupItemsModifyView([]);
        }
      } else {
        setMaintenanceCheckupItems([]);
        setMaintenanceCheckupItemsModifyView([]);
      }
    });
  };

  const [manualFile, setManualFile] = useState(null);
  const [fileLoading, setFileLoading] = useState(false);
  const [manualUpdateFile, setManualUpdateFile] = useState(null);
  const [fileUpdateLoading, setFileUpdateLoading] = useState(false);

  const hiddenFileInput = useRef(null);
  const hiddenUpdateFileInput = useRef(null);

  const handleFileClick = event => {
    console.log(1111);
    hiddenFileInput.current.click();
  };
  
  const handleUpdateFileClick = event => {
    console.log(1111);
    hiddenUpdateFileInput.current.click();
  };

  const handleFileChange = (e) => {
    setManualFile(e.target.files[0]);
  }

  const handleUpdateFileChange = (e) => {
    setManualUpdateFile(e.target.files[0]);
  }

  // 유지점검항목등록
  let onSubmitCheckList = (data, e) => {
    e.preventDefault();
    setFileLoading(true);

    const chkCycle = data.chkCycle;
    const chkItemNm = data.chkItemNm;
    const chkItemDtlNm = data.chkItemDtlNm;
    const chkItemType = "M";
    const equipmentCtgrId = equipmentCategoryLevel2Id;

    let dto = {
      chkItemType,
      equipmentCtgr: {
        id: equipmentCtgrId
      },
      //      id : null,
      chkCycle,
      chkItemNm,
      chkItemDtlNm
    };

    let formData = new FormData();
    formData.append("file", manualFile);
    formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );

    try {
      openModal(modals.confirmModal, {
        onSubmit : (value) => {
          try {
              const res = customFileAxios.post(`/api/maintenanceCheckupItems`, formData).then((res)=>{
                setFileLoading(false);
                e.target.value = '';
                maintenanceCheckupItemsList();
                alertMessage = t('message.common.alert.write.done');
                setAlertMessage(alertMessage);
                handleAlertClick();
                //checkListReset();
                setManualFile(null);
              })
              .catch((err)=>{
                console.log(err);
                setFileLoading(false);
                if (!err.response?.data?.message) {
                  alertMessage = err.message;
                  setAlertMessage(alertMessage);
                  handleAlertClick();
                } else if (err.response.data.message) {
                  alertMessage = err.response.data.message;
                  setAlertMessage(alertMessage);
                  handleAlertClick();
                }
                // if (isCancel(err)) {
                //   alert(err.message);
                // }
                // setUploadPercentage(-1);
              });
              // return res.data;
          } catch (error) {
              console.error("error :", error);
              throw error;
          }

          // axios({
          //   method: "post",
          //   url: process.env.REACT_APP_API_URL+"/api/maintenanceCheckupItems",
          //   data: formData,
          //   headers : {
          //     'Content-type' : 'multipart/form-data',
          //     accept : 'application/json,',
          //     'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
          //     'Accept-Language' : t('locale')
          //   }
          // }).then((res)=>{
          //   setFileLoading(false);
          //   e.target.value = '';
          //   maintenanceCheckupItemsList();
          //   alertMessage = t('message.common.alert.write.done');
          //   setAlertMessage(alertMessage);
          //   handleAlertClick();
          //   setManualFile(null);
          // })
          // .catch((err)=>{
          //   console.log(err);
          //   setFileLoading(false);
          //   if (!err.response?.data?.message) {
          //     alertMessage = err.message;
          //     setAlertMessage(alertMessage);
          //     handleAlertClick();
          //   } else if (err.response.data.message) {
          //     alertMessage = err.response.data.message;
          //     setAlertMessage(alertMessage);
          //     handleAlertClick();
          //   }
          // });
        },
        onClose : () => {
         //   console.log('close');
        },
        message: t('message.common.alert.write.question'),
      });
    } catch(error) {
      console.log(error);
      setFileLoading(false);
    }
    checkListReset();
  };

  // 유지점검항목수정
  let onSubmitCheckListUpdate = (data, e) => {
    e.preventDefault();
    setFileUpdateLoading(true);

    const chkListId = data.checkListIdUpdate;
    const chkCycle = data.chkCycleUpdate;
    const chkItemNm = data.chkItemNmUpdate;
    const chkItemDtlNm = data.chkItemDtlNmUpdate;
    const chkItemType = "M";
    const equipmentCtgrId = equipmentCategoryLevel2Id;

    let dto = {
      id : chkListId,
      chkItemType,
      equipmentCtgr: {
        id: equipmentCtgrId
      },
      chkCycle,
      chkItemNm,
      chkItemDtlNm
    };
    
    if (!manualUpdateFile && maintenanceCheckListItemFileId && maintenanceCheckListItemFileId !== 0) {
      dto.manualFile = {id : maintenanceCheckListItemFileId};
    }

    let formData = new FormData();
    formData.append("file", manualUpdateFile);
    formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );

    try {
      openModal(modals.confirmModal, {
        onSubmit : (value) => {
          try {
              const res = customFileAxios.patch(`/api/maintenanceCheckupItems/${chkListId}`, formData).then((res)=>{
                setFileUpdateLoading(false);
                e.target.value = '';
                maintenanceCheckupItemsList();
                setMaintenanceCheckListItemFileId(null);
                alertMessage = t('message.common.alert.modify.done');
                setAlertMessage(alertMessage);
                handleAlertClick();
                //checkListUpdateReset();
                //checkListReset();
                setManualUpdateFile(null);
              })
              .catch((err)=>{
                console.log(err);
                setFileUpdateLoading(false);
                if (!err.response?.data?.message) {
                  alertMessage = err.message;
                  setAlertMessage(alertMessage);
                  handleAlertClick();
                } else if (err.response.data.message) {
                  alertMessage = err.response.data.message;
                  setAlertMessage(alertMessage);
                  handleAlertClick();
                }
                // if (isCancel(err)) {
                //   alert(err.message);
                // }
                // setUploadPercentage(-1);
              });
              // return res.data;
          } catch (error) {
              console.error("error :", error);
              throw error;
          }
          
          // axios({
          //   method: "patch",
          //   url: process.env.REACT_APP_API_URL+"/api/maintenanceCheckupItems/"+chkListId,
          //   data: formData,
          //   headers : {
          //     'Content-type' : 'multipart/form-data',
          //     accept : 'application/json,',
          //     'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
          //     'Accept-Language' : t('locale')
          //   }
          // }).then((res)=>{
          //   setFileUpdateLoading(false);
          //   e.target.value = '';
          //   maintenanceCheckupItemsList();
          //   setMaintenanceCheckListItemFileId(null);
          //   alertMessage = t('message.common.alert.modify.done');
          //   setAlertMessage(alertMessage);
          //   handleAlertClick();
          //   setManualUpdateFile(null);
          // })
          // .catch((err)=>{
          //   console.log(err);
          //   setFileUpdateLoading(false);
          //   if (!err.response?.data?.message) {
          //     alertMessage = err.message;
          //     setAlertMessage(alertMessage);
          //     handleAlertClick();
          //   } else if (err.response.data.message) {
          //     alertMessage = err.response.data.message;
          //     setAlertMessage(alertMessage);
          //     handleAlertClick();
          //   }
          // });
        },
        onClose : () => {
         //   console.log('close');
        },
        message: t('message.common.alert.modify.question'),
      });
    } catch(error) {
      console.log(error);
      setFileUpdateLoading(false);
    }
  };

  // 유지점검항목 삭제
  const handleCheckListDeleteBtnClick = (param) => {
    openModal(modals.confirmModal, {
      onSubmit: (value) => {
        deleteMaintenanceCheckupItems(param).then((res) => {
          maintenanceCheckupItemsList();
        }).catch((err) => {
          console.log(err);
          if (!err.response?.data?.message) {
            alertMessage = err.message;
            setAlertMessage(alertMessage);
            handleAlertClick();
          } else if (err.response.data.message) {
            alertMessage = err.response.data.message;
            setAlertMessage(alertMessage);
            handleAlertClick();
          }
        });
      },
      onClose: () => {
      //  console.log('close');
      },
      message: t('message.common.alert.delete.question'),
    });
    checkListReset();
  };

  return (
    <div className='cal'>
    <div className="scroll_table scroll_table1 scroll_table2" style={{padding:"15px 0"}}>
      <div>
        <TableContainer>
        <form onSubmit={level1HandleSubmit(onSubmitLevel1)}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level1')}</TableCell>
                <TableCell className="th" align="center"></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
            { equipmentCategoryLevel1s && equipmentCategoryLevel1s.map(function(con, i) {
              if (equipmentCategoryLevel1sModifyView[i]) {  // 수정폼
                return (
              <TableRow key={i}>
                <TableCell>
                    <input type="hidden" {...level1UpdateRegister("level1Id")} value={equipmentCategoryLevel1s[i].id} />
                    <TextField id="outlined-basic" 
                    aria-invalid={!level1UpdateIsDirty ? undefined : level1UpdateErrors.level1NameUpdate ? "true" : "false"}
                    defaultValue={equipmentCategoryLevel1s[i].name} 
                    {...level1UpdateRegister("level1NameUpdate", {
                      required : t('message.common.error.text.level1.input')
                    })} 
                    sx={{ minWidth: '100%' }} />
                    {level1UpdateErrors.level1NameUpdate && <small role="alert"><br></br>{level1UpdateErrors.level1NameUpdate.message}</small>}
                </TableCell>
                <TableCell>
                  <Button variant="outlined" color="success" className="small_btn" 
                  onClick={level1UpdateHandleSubmit(onSubmitLevel1Update)}
                  >{t('message.common.btn.modify')}</Button>&nbsp;
                  <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                    let arr = Array.from({length : equipmentCategoryLevel1s.length},() => false);
                    arr[i] = false;
                    setEquipmentCategoryLevel1sModifyView(arr);
                    level1UpdateReset();
                  }}>{t('message.common.btn.cancel')}</Button>
                </TableCell>
              </TableRow>
                );
              } else {  // 목록
                return (
              <TableRow key={i}>
                <TableCell style={{cursor:"pointer"}} className={equipmentCategoryLevel1sSelected[i]} onClick={()=>{
                    selectEquipmentCategoryLevel1(i, equipmentCategoryLevel1s[i]);
                  }}>{equipmentCategoryLevel1s[i].name}</TableCell>
                <TableCell>
                  <Button variant="outlined" color="success" className="small_btn" onClick={()=>{
                    let arr = Array.from({length : equipmentCategoryLevel1s.length},() => false);
                    arr[i] = true;
                    setEquipmentCategoryLevel1sModifyView(arr);
                    level1UpdateReset();
                  }}>{t('message.common.btn.modify')}</Button>&nbsp;
                  <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                      handleEquipmentCategoryLevel1DeleteBtnClick(equipmentCategoryLevel1s[i].id);
                  }}>{t('message.common.btn.delete')}</Button>
                </TableCell>
              </TableRow>
                );
              }
            }) }
            </TableBody>

            <tfoot>
              <tr>
                <td>
                  <TextField id="outlined-basic" 
                  aria-invalid={!level1IsDirty ? undefined : level1Errors.level1Name ? "true" : "false"}
                  {...level1Register("level1Name", {
                    required : t('message.common.error.text.level1.input')
                  })} 
                  sx={{ minWidth: '100%' }} />
                  {level1Errors.level1Name && <small role="alert"><br></br>{level1Errors.level1Name.message}</small>}
                </td>
                <td>
                  <Button variant="contained" color="primary"
                  onClick={level1HandleSubmit(onSubmitLevel1)}
                  >{t('message.common.btn.add')}</Button>
                </td>
              </tr>
            </tfoot>
          </Table>
        </form>
        </TableContainer>

        <TableContainer>
        <form onSubmit={level2HandleSubmit(onSubmitLevel2)}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level2')}</TableCell>
                <TableCell className="th" align="center"></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
            { equipmentCategoryLevel2s && equipmentCategoryLevel2s.map(function(con, i) {
              if (equipmentCategoryLevel2sModifyView[i]) {  // 수정폼
                return (
              <TableRow key={i}>
                <TableCell>
                    <input type="hidden" {...level2UpdateRegister("level2Id")} value={equipmentCategoryLevel2s[i].id} />
                    <TextField id="outlined-basic" 
                    aria-invalid={!level2UpdateIsDirty ? undefined : level2UpdateErrors.level2NameUpdate ? "true" : "false"}
                    defaultValue={equipmentCategoryLevel2s[i].name} 
                    {...level2UpdateRegister("level2NameUpdate", {
                      required : t('message.common.error.text.level2.input')
                    })} 
                    sx={{ minWidth: '100%' }} />
                    {level2UpdateErrors.level2NameUpdate && <small role="alert"><br></br>{level2UpdateErrors.level2NameUpdate.message}</small>}
                </TableCell>
                <TableCell>
                  <Button variant="outlined" color="success" className="small_btn" 
                  onClick={level2UpdateHandleSubmit(onSubmitLevel2Update)}
                  >{t('message.common.btn.modify')}</Button>&nbsp;
                  <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                    let arr = Array.from({length : equipmentCategoryLevel2s.length},() => false);
                    arr[i] = false;
                    setEquipmentCategoryLevel2sModifyView(arr);
                    level2UpdateReset();
                  }}>{t('message.common.btn.cancel')}</Button>
                </TableCell>
              </TableRow>
                );
              } else {  // 목록
                return (
              <TableRow key={i}>
                <TableCell style={{cursor:"pointer"}} className={equipmentCategoryLevel2sSelected[i]} onClick={()=>{
                    selectEquipmentCategoryLevel2(i, equipmentCategoryLevel2s[i]);
                  }}>{equipmentCategoryLevel2s[i].name}</TableCell>
                <TableCell>
                  <Button variant="outlined" color="success" className="small_btn" onClick={()=>{
                    let arr = Array.from({length : equipmentCategoryLevel2s.length},() => false);
                    arr[i] = true;
                    setEquipmentCategoryLevel2sModifyView(arr);
                    level2UpdateReset();
                  }}>{t('message.common.btn.modify')}</Button>&nbsp;
                  <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                      handleEquipmentCategoryLevel2DeleteBtnClick(equipmentCategoryLevel2s[i].id);
                  }}>{t('message.common.btn.delete')}</Button>
                </TableCell>
              </TableRow>
                );
              }
            }) }
            </TableBody>
            {(equipmentCategoryLevel1Id || '') &&
            <tfoot>
              <tr>
                <td>
                  <TextField id="outlined-basic" 
                  aria-invalid={!level2IsDirty ? undefined : level2Errors.level2Name ? "true" : "false"}
                  {...level2Register("level2Name", {
                    required : t('message.common.error.text.level2.input')
                  })} 
                  sx={{ minWidth: '100%' }} />
                  {level2Errors.level2Name && <small role="alert"><br></br>{level2Errors.level2Name.message}</small>}
                </td>
                <td>
                  <Button variant="contained" color="primary"
                  onClick={level2HandleSubmit(onSubmitLevel2)}
                  >{t('message.common.btn.add')}</Button>
                </td>
              </tr>
            </tfoot>
            }
          </Table>
          </form>
        </TableContainer>
      </div> 

      <div>
        <div>
        <MainCard>
        <TableContainer>
          <form onSubmit={checkListHandleSubmit(onSubmitCheckList)}>
            <Table aria-label="simple table">
            <TableHead>
                <TableRow>
                  <TableCell className="th" align="center" style={{width:"100px"}}>{t('message.common.subtitle.inspection.cycle')}</TableCell>
                  <TableCell className="th" align="center">{t('message.common.subtitle.item')}</TableCell>
                  <TableCell className="th" align="center" style={{width:"400px"}}>{t('message.common.subtitle.inspection.details')}</TableCell>
                  <TableCell className="th" align="center">{t('message.common.subtitle.inspection.manual')}(File)</TableCell>
                  <TableCell className="th" align="center"></TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
            { maintenanceCheckupItems && maintenanceCheckupItems.map(function(con, i) {
              if (maintenanceCheckupItemsModifyView[i]) {  // 수정폼
                return (
                <TableRow key={i}>
                  <TableCell>
                    <input type="hidden" {...checkListUpdateRegister("checkListIdUpdate")} value={maintenanceCheckupItems[i].id} />
                    <Controller
                      control={checkListUpdateControl}
                      name="chkCycleUpdate"
                      render={({ onChange, value, ref }) => (
                        <CustomFormEnumSelect
                          style={{ minWidth: '90%' }}
                          label={t('message.common.subtitle.inspection.cycle')}
                          register={checkListUpdateRegister}
                          name={"chkCycleUpdate"}
                          requiredMessage={t('message.common.error.text.inspection.cycle.select')}
                          defaultValue={maintenanceCheckupItems[i].chkCycle}
                          list={getEnumValueByEnumName("CheckCycle")}
                        />
                      )}
                    />
                    {checkListUpdateErrors.chkCycleUpdate && <small role="alert"><br></br>{checkListUpdateErrors.chkCycleUpdate.message}</small>}
                  </TableCell>
                  <TableCell>
                    <TextField id="outlined-basic" 
                    aria-invalid={!checkListUpdateIsDirty ? undefined : checkListUpdateErrors.chkItemNmUpdate ? "true" : "false"}
                    defaultValue={maintenanceCheckupItems[i].chkItemNm} 
                    {...checkListUpdateRegister("chkItemNmUpdate", {
                      required : t('message.common.error.text.item.input')
                    })} 
                    sx={{ minWidth: '60%' }} />
                    {checkListUpdateErrors.chkItemNmUpdate && <small role="alert"><br></br>{checkListUpdateErrors.chkItemNmUpdate.message}</small>}
                  </TableCell>
                  <TableCell style={{width:"400px"}}>
                    <TextField id="outlined-basic" 
                    aria-invalid={!checkListUpdateIsDirty ? undefined : checkListUpdateErrors.chkItemDtlNmUpdate ? "true" : "false"}
                    defaultValue={maintenanceCheckupItems[i].chkItemDtlNm} 
                    {...checkListUpdateRegister("chkItemDtlNmUpdate", {
                      required : t('message.common.error.text.inspection.details.input')
                    })} 
                    sx={{ minWidth: '60%' }} />
                    {checkListUpdateErrors.chkItemDtlNmUpdate && <small role="alert"><br></br>{checkListUpdateErrors.chkItemDtlNmUpdate.message}</small>}
                  </TableCell>
                  <TableCell align="center" className="noteicon">
                    <LoadingButton variant="contained" color="primary"
                     onClick={handleUpdateFileClick}
                     loading={fileUpdateLoading}
                    >
                    {t('message.common.btn.upload')}
                    <input type="file"
                      accept=".txt,.jpg,.jpeg,.png,.pdf,.zip,.mp4" 
                      ref={hiddenUpdateFileInput}
                      onChange={handleUpdateFileChange}
                      style={{display:'none'}} 
                    />
                    </LoadingButton>
                    <br/>{manualUpdateFile && manualUpdateFile.name}
                  </TableCell>
                  <TableCell>
                    <Button variant="outlined" color="success" className="small_btn" onClick={
                      checkListUpdateHandleSubmit(onSubmitCheckListUpdate)
                    }>{t('message.common.btn.modify')}</Button>&nbsp;
                    <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                      let arr = Array.from({length : maintenanceCheckupItems.length},() => false);
                      arr[i] = false;
                      setMaintenanceCheckupItemsModifyView(arr);
                      setFileUpdateLoading(false);
                      checkListUpdateReset();
                    }}>{t('message.common.btn.cancel')}</Button>
                  </TableCell>
                </TableRow>
                )
              } else {  // 목록
                return (
                <TableRow key={i}>
                  <TableCell style={{width:"100px"}}>{getEnumValueByEnumNameAndCode("CheckCycle", maintenanceCheckupItems[i].chkCycle) && getEnumValueByEnumNameAndCode("CheckCycle", maintenanceCheckupItems[i].chkCycle)[0].title}</TableCell>
                  <TableCell>{maintenanceCheckupItems[i].chkItemNm}</TableCell>
                  <TableCell style={{width:"400px"}}>{maintenanceCheckupItems[i].chkItemDtlNm}</TableCell>
                  <TableCell align="center" className="noteicon">
                    {maintenanceCheckupItems[i].manualFile && <PdfLayer file={maintenanceCheckupItems[i].manualFile} />}
                  </TableCell>
                  <TableCell>
                    <Button variant="outlined" color="success" className="small_btn" onClick={()=>{
                      let arr = Array.from({length : maintenanceCheckupItems.length},() => false);
                      arr[i] = true;
                      setMaintenanceCheckupItemsModifyView(arr);
                      if (maintenanceCheckupItems[i].manualFile && maintenanceCheckupItems[i].manualFile.id) {
                        setMaintenanceCheckListItemFileId(maintenanceCheckupItems[i].manualFile.id);
                      }
                      checkListUpdateReset();
                    }}>{t('message.common.btn.modify')}</Button>&nbsp;
                    <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                      handleCheckListDeleteBtnClick(maintenanceCheckupItems[i].id);
                      setMaintenanceCheckListItemFileId(null);
                    }}>{t('message.common.btn.delete')}</Button>
                  </TableCell>
                </TableRow>
                  )
              }
            })}
            </TableBody>
            {(equipmentCategoryLevel2Id || '') &&
            <tfoot>
                <tr>
                <td className="field" style={{width:"100px"}}>
                  <Controller
                    aria-invalid={!checkListIsDirty ? undefined : checkListErrors.chkCycle ? "true" : "false"}
                    control={checkListControl}
                    name="chkCycle"
                    render={({ field: {name} }) => (
                      <CustomFormEnumSelect
                        style={{ minWidth: '90%' }}
                        label={t('message.common.subtitle.inspection.cycle')}
                        register={checkListRegister}
                        name={name}
                        requiredMessage={t('message.common.error.text.inspection.cycle.select')}
                        defaultValue={''}
                        list={getEnumValueByEnumName("CheckCycle")}
                      />
                    )}
                  />
                  {checkListErrors.chkCycle && <small role="alert"><br></br>{checkListErrors.chkCycle.message}</small>}
                </td>
                <td className="field">
                  <TextField id="outlined-basic" 
                  aria-invalid={!checkListIsDirty ? undefined : checkListErrors.chkItemNm ? "true" : "false"}
                  defaultValue={''} 
                  {...checkListRegister("chkItemNm", {
                    required : t('message.common.error.text.item.input')
                  })} 
                  sx={{ minWidth: '90%' }} />
                  {checkListErrors.chkItemNm && <small role="alert"><br></br>{checkListErrors.chkItemNm.message}</small>}
                </td>
                <td className="field" style={{width:"400px"}}>
                  <TextField id="outlined-basic" 
                  aria-invalid={!checkListIsDirty ? undefined : checkListErrors.chkItemDtlNm ? "true" : "false"}
                  defaultValue={''} 
                  {...checkListRegister("chkItemDtlNm", {
                    required : t('message.common.error.text.inspection.details.input')
                  })} 
                  sx={{ minWidth: '90%' }} />
                  {checkListErrors.chkItemDtlNm && <small role="alert"><br></br>{checkListErrors.chkItemDtlNm.message}</small>}
                </td>
                <td className="field">
                    <LoadingButton variant="contained" color="primary"
                     onClick={handleFileClick}
                     loading={fileLoading}
                    >
                    {t('message.common.btn.upload')}
                    <input type="file"
                      accept=".txt,.jpg,.jpeg,.png,.pdf,.zip,.mp4" 
                      ref={hiddenFileInput}
                      onChange={handleFileChange}
                      style={{display:'none'}} 
                    />
                    </LoadingButton>
                    <br/>{manualFile && manualFile.name}
                </td>
                <td>
                  <Button variant="contained" color="primary" onClick={checkListHandleSubmit(onSubmitCheckList)}>{t('message.common.btn.add')}</Button>
                </td>
                </tr>
            </tfoot>
            }
            </Table>
          </form>
        </TableContainer>
        </MainCard>
        </div>
      </div>      
    </div>
    </div>
  );
}
 
export default CheckListMaintenanceSetting;
